var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button app-delete-button" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.active,
            expression: "!active",
          },
        ],
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.click.apply(null, arguments)
          },
        },
      },
      [_vm._t("default")],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.active,
            expression: "active",
          },
        ],
      },
      [
        _c(
          "span",
          {
            staticClass: "has-text-success has-cursor-pointer",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.confirm.apply(null, arguments)
              },
            },
          },
          [
            _c("dc-icon", {
              attrs: { icon: "check", size: "lg", library: "fas" },
            }),
          ],
          1
        ),
        _c(
          "span",
          {
            staticClass: "has-text-danger has-cursor-pointer",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.cancel.apply(null, arguments)
              },
            },
          },
          [
            _c("dc-icon", {
              attrs: { icon: "times", size: "lg", library: "fas" },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }